import { Link, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { primary } from "../../../../theme/constants";
import HappyJourney from "../../../../assets/images/Happy-Journey.png";

interface IProps {
  fuelCost: string;
}

const FuelCost = ({ fuelCost }: IProps) => {
  return (
    <>
      <Box
        sx={{ border: 1, padding: 3, borderRadius: 2, borderColor: primary }}
      >
        <Box display="column" justifyContent="center" alignItems="center">
          {/* <Typography variant="h4" style={{ color: primary, fontSize: "40px" }}>
   &#8377;
 </Typography> */}
          <Typography
            variant="h5"
            style={{ textAlign: "center", color: primary }}
          >
            Your fuel cost
          </Typography>
          {!isNaN(parseFloat(fuelCost)) ? (
            <Typography
              variant="h1"
              style={{
                fontWeight: "900",
                fontSize: "64px",
                textAlign: "center",
              }}
            >
              {fuelCost}
            </Typography>
          ) : null}
        </Box>
      </Box>
      <Box display="flex" justifyContent="center">
        <img
          src={HappyJourney}
          style={{ margin: "30px 0px 30px 0px" }}
          alt="HappyJourney"
          height="130"
        />
      </Box>
      <Stack marginTop={8} direction="row" spacing={4} justifyContent="center">
        <Link href="https://kyfc.netlify.app/terms_of_use.pdf" target="_blank">
          <Typography fontStyle="italic">Terms & Conditions</Typography>
        </Link>
        <Link
          href="https://kyfc.netlify.app/kyfc_privacy_policy.pdf"
          target="_blank"
        >
          <Typography fontStyle="italic">Privacy Policy</Typography>
        </Link>
      </Stack>
      <Stack marginTop={3} direction="row" spacing={1} justifyContent="center">
        <Typography fontStyle="italic">Powered by</Typography>
        <Link href="https://theqoq.com">
          <Typography color="primary">THEQOQ</Typography>
        </Link>
      </Stack>
    </>
  );
};

export default FuelCost;
